import _extends from "babel-runtime/helpers/extends";
import { SRE_CANCEL_SESSION } from "../../sreactions";
import SrePlaySound from ".";

export var initialState = {
  playsound: {
    status: "init",
    sessionId: null,
    canceled: false,
    playing: false,
    currentTime: null,
    sessionData: null,
    soundObj: null,
    soundLog: null
  }
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case SrePlaySound.PLAY_SOUND_SESSION_STORE_SOUND:
      var soundObj = action.payload.soundObj || null;
      var soundLog = action.payload.soundLog || null;
      return _extends({}, state, {
        playsound: _extends({}, initialState.playsound, {
          status: "sessionStoreSound",
          soundObj: soundObj,
          soundLog: soundLog
        })
      });

    case SrePlaySound.PLAY_SOUND_SESSION_START:
      var sessionId = action.payload.sessionId || 0;
      return _extends({}, state, {
        playsound: _extends({}, state.playsound, {
          status: "sessionStart",
          playing: true,
          sessionId: sessionId
        })
      });

    case SrePlaySound.PLAY_SOUND_SESSION_PROGRESS:
      var session = action.payload.session;

      var currentTime = session ? session.getCurrentTimeMS() : 0;
      return _extends({}, state, {
        playsound: _extends({}, state.playsound, {
          status: "sessionProgress",
          sessionData: session || null,
          currentTime: currentTime
        })
      });

    case SrePlaySound.PLAY_SOUND_SESSION_END:
      return _extends({}, state, {
        playsound: _extends({}, state.playsound, {
          status: "sessionEnd",
          sessionData: action.payload.session || null,
          playing: false
        })
      });

    case SRE_CANCEL_SESSION:
      return _extends({}, state, {
        playsound: _extends({}, initialState.playsound, {
          status: "sessionCancel",
          canceled: true
        })
      });

    default:
      return state;
  }
};

export default reducer;